// extracted by mini-css-extract-plugin
export default {"card":"SongCardPublic_card__+VCJV","image":"SongCardPublic_image__+he5J"};